// assets
import { IconDashboard, IconClipboardList } from '@tabler/icons';

// constant
const icons = { IconDashboard, IconClipboardList };
const envType = process.env.REACT_APP_ENV_TYPE ? ` [${process.env.REACT_APP_ENV_TYPE}]` : '';

// ==============================|| DASHBOARD MENU ITEMS kiosk ||============================== //

const menuKiosk = {
  id: 'dashboard2',
  title: '메뉴 - 키오스크2차' + envType,
  type: 'group',
  children: [
    {
        id: 'kiosk-users',
        title: '사용자 관리',
        type: 'item',
        url: '/kiosk-users',
        icon: icons.IconClipboardList,
        breadcrumbs: false
    },
    {
        id: 'kiosk-banners',
        title: '배너 관리',
        type: 'item',
        url: '/kiosk-banners',
        icon: icons.IconClipboardList,
        breadcrumbs: false
    },
    // {
    //   id: 'kiosk-data-rooms',
    //   title: '자료실 컨텐츠 관리',
    //   type: 'item',
    //   url: '/kiosk-data-rooms',
    //   icon: icons.IconClipboardList,
    //   breadcrumbs: false
    // },
    {
      id: 'kiosk-result-management',
      title: '검사정보 관리',
      type: 'collapse',
      icon: icons.IconClipboardList,
      children: [
        {
          id: 'kiosk-total-tests',
          title: '종합검사 결과 관리',
          type: 'item',
          url: '/kiosk-total-tests',
          breadcrumbs: false
      },
      {
          id: 'kiosk-surveys',
          title: '설문검사 결과 관리',
          type: 'item',
          url: '/kiosk-surveys',
          breadcrumbs: false
        },
        {
          id: 'kiosk-hear-tests',
          title: '청력선별검사 결과 관리',
          type: 'item',
          url: '/kiosk-hear-tests',
          breadcrumbs: false
        },
        {
            id: 'kiosk-noise-tests',
            title: '소음하검사 결과 관리',
            type: 'item',
            url: '/kiosk-noise-tests',
            breadcrumbs: false
        },
        {
            id: 'kiosk-eardrum-tests',
            title: '고막검사 결과 관리',
            type: 'item',
            url: '/kiosk-eardrum-tests',
            breadcrumbs: false
        },
      ]
    },
    {
      id: 'device-management',
      title: '키오스크 기기 관리',
      type: 'collapse',
      icon: icons.IconClipboardList,
      children: [
        {
          id: 'pcm-set',
          title: 'PCM 데이터 관리',
          type: 'item',
          url: '/kiosk-pcm-sets',
          breadcrumbs: false
        },
        {
          id: 'gps-location',
          title: '위치정보 관리',
          type: 'item',
          url: '/kiosk-gps-locations',
          breadcrumbs: false
        },
        {
          id: 'devices-list',
          title: '기기정보 관리',
          type: 'item',
          url: '/kiosk-devices-list',
          breadcrumbs: false
        },
        {
          id: 'kiosk-general-codes',
          title: '공통 코드 관리',
          type: 'item',
          url: '/kiosk-general-codes',
          breadcrumbs: false
        },
      ]
    },

  ]
};




export default menuKiosk;
